// internal settings PageCodes to be used only for native navigation via useAppNavigation

export enum PageCode {
	'dashboard' = 'dashboard',
	'autorizace' = 'autorizace',
	'prihlaseni' = 'prihlaseni',
	'odhlaseni' = 'odhlaseni',
	'reza-vyber' = 'reza-vyber',
	'sluzba' = 'sluzba',
	'nastaveni' = 'nastaveni',
	'nastaveni-kontakt' = 'nastaveni-kontakt',
	'nastaveni-datovky' = 'nastaveni-datovky',
	'nastaveni-upozorneni' = 'nastaveni-upozorneni',
	'registr-ZP' = 'registr-ZP',
	'cestovni-pas' = 'cestovni-pas',
	'obcansky-prukaz' = 'obcansky-prukaz',
	'ridicsky-prukaz' = 'ridicsky-prukaz',
	'vlastni-doklad' = 'vlastni-doklad',
	'doklady' = 'doklady',
	'profil-ROB' = 'profil-ROB',
	'profil-ROS' = 'profil-ROS',
	'profil-certifikaty' = 'profil-certifikaty',
	'profil-edoklady' = 'profil-edoklady',
	'profil-reza' = 'profil-reza',
	'drozd' = 'drozd',
	'drozd-registrations' = 'drozd-registrations',
	'drozd-registration-detail' = 'drozd-registration-detail',
	'drozd-countries' = 'drozd-countries',
	'drozd-insurance-companies' = 'drozd-insurance-companies',
	'drozd-add-registration' = 'drozd-add-registration',
	'drozd-signpost-countries' = 'drozd-signpost-countries',
	'moje-soubory' = 'moje-soubory',
	'moje-soubory-detail' = 'moje-soubory-detail',
	'podani' = 'podani',
	'epetice' = 'epetice',
	'ppdf-souhlasy' = 'ppdf-souhlasy',
	'epetice-detail' = 'epetice-detail',
	'epetice-detail-editace' = 'epetice-detail-editace',
	'epetice-nova' = 'epetice-nova',
	'moje-podani' = 'moje-podani',
	'moje-podani-osvedceni' = 'moje-podani-osvedceni',
	'moje-podani-autorizace' = 'moje-podani-autorizace',
	'moje-podani-detail' = 'moje-podani-detail',
	'zdravotnicka-dokumentace' = 'zdravotnicka-dokumentace',
	'datove-schranky' = 'datove-schranky',
	'datove-schranky-seznam' = 'datove-schranky-seznam',
	'datove-schranky-zprava' = 'datove-schranky-zprava',
	'datove-schranky-odpoved' = 'datove-schranky-odpoved',
	'datove-schranky-dalsi' = 'datove-schranky-dalsi',
	'datove-schranky-nova' = 'datove-schranky-nova',
	'datove-schranky-pripojeni' = 'datove-schranky-pripojeni',
	'podpora' = 'podpora',
	'muj-katastr-nemovitosti' = 'muj-katastr-nemovitosti',
	'registr-SV' = 'registr-silnicnich-vozidel',
	'registr-SV-detail' = 'registr-silnicnich-vozidel-detail',
	'registr-ridicu' = 'registr-ridicu',
	'upozorneni' = 'upozorneni',
	'kde-o-mne-stat-vede-udaje' = 'kde-o-mne-stat-vede-udaje',
	'rozcestnik' = 'rozcestnik',
	'sprava-souhlasu' = 'sprava-souhlasu',
	'sprava-souhlasu-detail' = 'sprava-souhlasu-detail',
	'uzivatelska-prirucka' = 'uzivatelska-prirucka',
	'reza' = 'reza',
	'sluzby' = 'sluzby',
	'sluzby-oblibene' = 'sluzby-oblibene',
	'casto-se-ptate' = 'casto-se-ptate',
	'uzitecne-odkazy' = 'uzitecne-odkazy',
	'landing-page' = 'landing-page',
	'vysledky-vyhledavani' = 'vysledky-vyhledavani',
	'vyhledavani-sluzby' = 'vysledky-vyhledavani.sluzby',
	'vyhledavani-uzitecne-odkazy' = 'vysledky-vyhledavani.uzitecne-odkazy',
	'vyhledavani-caste-dotazy' = 'vysledky-vyhledavani.caste-dotazy',
}
